import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import "antd/dist/antd.css";
import { DatePicker } from 'antd';
import Swal from 'sweetalert2';
import moment from 'moment';
import axios from 'axios';
import { baseURL } from '../backend_url';
import { formatDate } from '../commonFunctions';
import { MDBDataTable } from 'mdbreact';
import { ExportReactCSV } from './ExportReactCSV';
import { Alert } from "@mui/material";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Box } from '@mui/material';
import Papa from 'papaparse';



export default function ClickUtilizationReport() {

  var obj_company_detail = "";

  const [clickData, setClickData] = useState({
    accountName: '',
    rows: [],
    totalClicksAccount: 0
  });

  const [companyDetail, setcompanyDetail] = useState([{}]);
  const [companyName, setCompanyName] = useState("");
  const [company_id, setcompany_id] = useState("");
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loggedInUserDetail, setLoggedInUserDetail] = useState({});
  const [locationName, setLocationName] = useState("");
  const [locationDetail, setLocationDetail] = useState([{}]);
  const [locationID, setLocationID] = useState("");
  const [tableData, setTableData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [allLocationData, setAllLocationData] = useState([]);
  const [lgShow1, setLgShow1] = useState(false);
  const [fetchClicked, setFetchClicked] = useState(false);
  

  //This is for scrolling
  const titleRef = useRef()

  //API call
  useEffect(() => {

    const loggedInUser = sessionStorage.getItem("user_token");
    const foundUser = JSON.parse(loggedInUser);
    console.log('foundUser', foundUser)
    setLoggedInUserDetail(foundUser)
    // if (foundUser.role === 'SuperAdmin') {
      
    // }
    // else {
    //   setRateCodeAccess(foundUser.access['Adjustment_Rate Code Selection']);
    //   setOTAAccess(foundUser.access['Adjustment_OTA Selection']);
    //   setDaysApplicableAccess(foundUser.access['Adjustment_Days Applicable Selection']);
    //   setCarClassAccess(foundUser.access['Adjustment_Car Class Selection']);
    //   setAdjTypeAccess(foundUser.access['Adjustment_Type of Adjustment/ Promotion / Blackout']);
    // }

    if (foundUser.role === 'SuperAdmin') {
      axios.get(baseURL + "/get_company_details_for_users")
        .then((res) => {
          setcompanyDetail(res.data);
        });
    }
    else {
      fetch(baseURL + "/get_company_details_for_users_accessWise/" + foundUser.access['Adjustment_Account Access'] + "*"
        + foundUser.account_id + "*" + foundUser.account_type.account_type)
        .then((res) => res.json())
        .then((data) => {

          setcompanyDetail(data);

        });
    }



  }, []);

  //Trigger on Company Name Dropdown Changes , getting Company ID
  useEffect(() => {

    if (companyDetail && companyName) {

      setLgShow1(false);
      setFetchClicked(false);
      setLocationName("");
      setLocationDetail([]);
      console.log('companyDetail',companyDetail)

      obj_company_detail = companyDetail.filter(
        (value) => value.company_name === companyName
      )[0];
      const company_id_temp = obj_company_detail._id;
      const company_type = obj_company_detail.account_type;
      setcompany_id(company_id_temp);


      axios.get(baseURL + "/get_company_location/" + company_id_temp)
        .then((res) => {

          let allTemp = res.data.res;

           //creating location name vs ID hash .... eg: hashLocationNameVsID['982327-YYC'] = 'Calgary Airport'
           let hash_location_name_id = {}
           allTemp.map((k) => hash_location_name_id[k.location_id] = k.location_name)
           //creating location name vs ID hash ends

          if (loggedInUserDetail.role === 'SuperAdmin') {
            if (allTemp.length > 0) {
              let tempArr = [];
              let tempObj = {};
              for (let i = 0; i < allTemp.length; i = i + 4) {
                let tempArr2 = [];
                for (let j = i; j < i + 4; j++) {
                  if (allTemp[j] !== undefined) {
                    tempArr2.push(allTemp[j].location_name);
                    tempObj[allTemp[j].location_name] = false;
                  }
                }
                tempArr.push(tempArr2);
              }

              setAllLocationData(tempArr);
              setSelectedLocation(tempObj);
            }
          }
          else if (company_type === 'Affiliate' && loggedInUserDetail.account_type.account_type === 'Corporate') {

            if (allTemp.length > 0) {
              let tempArr = [];
              let tempObj = {};
              for (let i = 0; i < allTemp.length; i = i + 4) {
                let tempArr2 = [];
                for (let j = i; j < i + 4; j++) {
                  if (allTemp[j] !== undefined) {
                    tempArr2.push(allTemp[j].location_name);
                    tempObj[allTemp[j].location_name] = false;
                  }
                }
                tempArr.push(tempArr2);
              }

              setAllLocationData(tempArr);
              setSelectedLocation(tempObj);
            }
          }
          else {
            axios.post(baseURL + "/get_individual_user_details", { 'user_email': loggedInUserDetail.userEmail } )
              .then((data) => {

                if (allTemp.length > 0) {

                  let tempArr = [];
                  let tempObj = {};

                  allTemp = allTemp.filter((val) => val !== undefined && data.data[0].location_allocated[val.location_id])

                  for (let i = 0; i < allTemp.length; i = i + 4) {
                    let tempArr2 = [];
                    for (let j = i; j < i + 4; j++) {
                      if (allTemp[j] !== undefined && data.data[0].location_allocated[allTemp[j].location_id]) {
                        tempArr2.push(allTemp[j].location_name);
                        tempObj[allTemp[j].location_name] = false;
                      }
                    }
                    tempArr.push(tempArr2);
                  }

                  setAllLocationData(tempArr);
                  setSelectedLocation(tempObj);
                }
              })
          }


        }).catch((e) => { });


      //API call for getting data from DB
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      };

      fetch(baseURL + "/get_company_location/" + company_id_temp, requestOptions)
        .then((res) => res.json())
        .then((data) => {

          let allTemp = data.res;
          if (loggedInUserDetail.role === 'SuperAdmin') {
            if (allTemp.length > 0) {

              setLocationDetail(allTemp);

            }
          }
          else if (company_type === 'Affiliate' && loggedInUserDetail.account_type.account_type === 'Corporate') {

            if (allTemp.length > 0) {
              setLocationDetail(allTemp);

            }
          }
          else {
            axios.post(baseURL + "/get_individual_user_details" , { 'user_email': loggedInUserDetail.userEmail })
              .then((data) => {
                if (allTemp.length > 0) {

                  allTemp = allTemp.filter((val) => val !== undefined && data.data[0].location_allocated[val.location_id]);

                  setLocationDetail(allTemp);
                }
              }
              )
          }
        });
    }

  }, [companyName]);


  useEffect(()=>{

    let temp_location_id = locationDetail.filter((loc) => (loc.location_name === locationName)).map((val) => val.location_id)
    setLocationID(temp_location_id[0]);
    console.log('locationDetail',locationDetail)
    console.log('location',temp_location_id[0])

  },[locationName])
  
  //Option for company name
  const companyNameOptions = companyDetail.map((value) => (

    { value: value.company_name, label: value.company_name }
  ));


  const handleInputChangeCompanyName = characterEntered => {
    setCompanyName(characterEntered.value);
  };


  const handleInputChangeLocationName = characterEntered => {
    setLocationName(characterEntered.value);
  };

  //Option for Location name
  const locationNameOptions = locationDetail.map((value) => (

    { value: value.location_name, label: value.location_name }
  ));

  // Handle Submit Starts
  const handleFetch = (e) => {

    e.preventDefault();
    if (companyName === "") {
      Swal.fire('Please select an account to proceed ahead');
      return;
    }
    if (locationName === "") {
      Swal.fire('Please select an location to proceed ahead');
      return;
    }

    if (fromDate === "") {
      Swal.fire('Please select From Date to proceed ahead');
      return;
    }
    if (toDate === "") {
      Swal.fire('Please select To Date to proceed ahead');
      return;
    }
    if(fromDate > toDate){
      Swal.fire('From Date can not be greater than To Date');
      return;
    }

    const d = new Date();
    const id = d.getTime().toString();

    //location into 1D array
    let location_arr = [];
    let keyArr1 = Object.keys(selectedLocation);
    for (let i = 0; i < keyArr1.length; i++) {
      if (selectedLocation[keyArr1[i]])
        location_arr.push(keyArr1[i]);
    }

    //API call to fetch Data
    axios.post(baseURL + "/get_automation_scheduler_jobs", {
      'account_id': company_id.toString(),
      'location_name': locationID,
      'from_date': fromDate,
      'to_date': toDate
    })
      .then((res) => {
        setTableData(res.data);
        setOriginalData(res.data)
      }).catch((e) => { });
      
  }
  const handleDownloadClick = (row) => {
    // Define a mapping of old keys to new headers (ensuring the correct order)
    const headerMapping = {
        locationName: "Location Name",
        pStartDate: "Pickup Date",
        pLor: "LOR",
        pSippCode: "Routes SIPP Code",
        pCompSippCode: "Competitor SIPP Code",
        pCompetitorName: "Competitor Name",
        pCompetitorPrice: "Competitor Price",
        pRangeValue: "Range Value",
        pStrategy: "Strategy",
        pMinimumRate: "Is from Minimum Rate Mapping",
    };
    const arrayLength = Array.isArray(row.pFinalArray.pCompSippCode)
      ? row.pFinalArray.pCompSippCode.length
      : 0;
    // Now build `formattedData` by iterating over indices:
    const formattedData = [];
    for (let i = 0; i < arrayLength; i++) {
      let newItem = {};
      // Loop over your headerMapping keys, get values for index i
      Object.entries(headerMapping).forEach(([oldKey, newHeader]) => {
        let value = row.pFinalArray[oldKey];
        // If the value is an array, get the item at i, else take value as is
        if (Array.isArray(value)) {
          value = value[i];
        }
        // Replace NaN, undefined, or null with "-" for "Competitor Price"
        if (newHeader === "Competitor Price" && (isNaN(value) || value === undefined || value === null)) {
          value = "-";
        }
        newItem[newHeader] = value;
      });
      formattedData.push(newItem);
    }
    // Then convert to CSV as you did
    const csv = Papa.unparse({
      fields: Object.values(headerMapping), // Headers in correct order
      data: formattedData.map(row => Object.values(row))
    });
    const fileName = `${row.automationName}_${row.created_on}.csv`;
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    const filteredData = originalData.filter((row) => {
      return (
        row.automationName.toLowerCase().includes(query)
        // row.pLor.toLowerCase().includes(query) ||
        // row.pSippCode.toLowerCase().includes(query) ||
        // row.pCompetitorName.toLowerCase().includes(query) ||
        // row.pCompSippCode.toLowerCase().includes(query)
      );
    });
    setTableData(filteredData);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = tableData.slice(indexOfFirstRow, indexOfLastRow);

  const totalPages = Math.ceil(tableData.length / rowsPerPage);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <>

      <div>
      <div className="row pt-3">
        <div className="col-11 mx-3">
          {/* First Row */}
          <div className="row">
            <div className="col-md-2 mb-3">
              <label htmlFor="company_name" className="form-label">
                Account Name*
              </label>
            </div>
            <div className="col-md-3 mb-3">
              <Select
                value={{ value: companyName, label: (companyName ? companyName : "Select Account Name") }}
                inputId="company_name"
                name="company_name"
                options={companyNameOptions}
                onChange={handleInputChangeCompanyName}
              />
            </div>
            <div className="col-md-1 mb-3"></div>
            <div className="col-md-2 mb-3">
              <label htmlFor="location_name" className="form-label">
                Location Name*
              </label>
            </div>
            <div className="col-md-3 mb-3">
              <Select
                value={{ value: locationName, label: (locationName ? locationName : "Select Location Name") }}
                inputId="location_name"
                name="location_name"
                options={locationNameOptions}
                onChange={handleInputChangeLocationName}
              />
            </div>
          </div>{/* first row wrapper ends */}
          {/* Second Row */}
          <div className="row mt-3">
            <div className="col-md-2 mb-3">
              <label htmlFor="location_name" className="form-label">
                From Date*
              </label>
            </div>
            <div className="col-md-3 mb-3">
              <DatePicker size="large" format='MM-DD-YYYY' placeholder='mm-dd-yyyy' onChange={(date, dateString) => {
                setFromDate(date);
              }}
                style={{ width: '100%', position: 'relative' }}
                value={fromDate ? moment(new Date(fromDate)) : fromDate}
                getPopupContainer={(triggerNode) => {
                  return triggerNode.parentNode;
                }}
              />
            </div>
            <div className="col-md-1 mb-3"></div>
            <div className="col-md-2 mb-3">
              <label htmlFor="location_name" className="form-label">
                To Date*
              </label>
            </div>
            <div className="col-md-3 mb-3">
              <DatePicker size="large" format='MM-DD-YYYY' placeholder='mm-dd-yyyy'
                onChange={(date, dateString) => setToDate(date)} style={{ width: '100%' }}
                value={toDate ? moment(new Date(toDate)) : toDate}

                getPopupContainer={(triggerNode) => {
                  return triggerNode.parentNode;
                }}
              />
            </div>
          </div>{/* second row wrapper ends */}
          {companyName ? (<>
            {/* Third row */}
            <div className="row mt-3">
              <div className="col-12 mb-4 ">
                <div className="row mb-3">{/* Twelveth row wrapper modal starts */}
                  <div className="col-md-2  mt-3"></div>

                  <div className="col-md-10 mt-3 d-flex justify-content-end">

                    <button type="submit" className="btn btn-success" onClick={(e) => handleFetch(e)}>
                      Fetch
                    </button>
                  </div>
                </div>{/* Twelveth row wrapper modal ends */}
              </div>
            </div>{/* Third row wrapper ends */}
          </>) : ("")}
          {/* Fourth Row*/}
        </div>
      </div>  
      {tableData.length > 0 ? (
          <div className="row mt-4">
              <div className="col-md-12">
              {/* Header and Download Button */}
              <div id="table-section" className="row mt-3 mb-3">
                  <div className="col-md-8 text-start">
                  <h4>Automation Scheduler Jobs Info</h4>
                  </div>
              </div>
              {/* Table */}
              <div className="table-responsive">
                  <table className="table table-bordered table-hover">
                  <thead className="table-dark">
                      <tr>
                      <th className="text-center">S.No</th>  
                      <th className="text-center">Location Name</th>
                      <th className="text-center">Automation Name</th>
                      <th className="text-center">Created On</th>
                      <th className="text-center">Created By</th>
                      <th className="text-center">Download</th>
                      </tr>
                  </thead> 
                  <tbody>
                    {currentRows.map((row, index) => (
                      <tr key={indexOfFirstRow + index}>
                        <td className="text-center">{indexOfFirstRow + index + 1}</td>
                        <td className="text-center">{row.location_name}</td>
                        <td className="text-center">{row.automationName}</td>
                        <td className="text-center">{row.created_on}</td>
                        <td className="text-center">{row.created_by}</td>
                        <td className="text-center">
                          <button
                            onClick={() => handleDownloadClick(row)}
                            className="text-blue-600 hover:text-blue-800"
                            title="Download"
                          >
                            ⬇️
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  </table>
                  <div className="d-flex justify-content-center mt-3">
                    <nav>
                      <ul className="pagination">
                        {[...Array(totalPages)].map((_, i) => (
                          <li
                            key={i}
                            className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
                          >
                            <button className="page-link" onClick={() => handlePageChange(i + 1)}>
                              {i + 1}
                            </button>
                          </li>
                        ))}
                      </ul>
                    </nav>
                  </div>
              </div>
            </div>
          </div>
          ) : (
          <tr>
            <td className="p-4 font-semibold text-center">
              <strong>No Jobs found for this search</strong>
            </td>
          </tr>
      )}
      </div> 
    </>
  );
}
